export const DISC_LETTER_NUMBER = 76884;
